@if (loading) {
  <div class="loading-screen">{{ t('HubLoading') }}</div>
}

@if (!loading && session; as activeSession) {
  <header class="hub-header header" [ngStyle]="{'--accent-color': activeSession.ngo?.color || '#29133d'}">
    <a class="brand" routerLink="/">
      @if (logoUrl) {
        <img [src]="logoUrl" [alt]="activeSession.ngo?.name || 'Goodvantage'">
      }
      @if (!logoUrl) {
        <span>{{ activeSession.ngo?.name || 'Goodvantage' }}</span>
      }
      @if (activeSession.environment === 'test') {
        <small>test</small>
      }
    </a>
    <div class="header-actions">
      <label class="language-select-label">
        <span class="visually-hidden">Language</span>
        <select class="language-select" [ngModel]="activeSession.activeLanguage" (ngModelChange)="setLanguage($event)" aria-label="Language">
          @for (language of activeSession.languages; track language) {
            <option [value]="language">{{ language }}</option>
          }
        </select>
      </label>
      @if (activeSession.authenticated) {
        <button type="button" class="text-button" (click)="logout()">{{ t('HubLogout') }}</button>
      }
    </div>
  </header>
  @if (!activeSession.authenticated) {
    <main class="login-shell">
      <form class="login-card" (ngSubmit)="authenticate()">
        <h1>Goodvantage Hub</h1>
        <p>{{ t('HubLoginIntro') }}</p>
        @if (loginError) {
          <p class="error-message">{{ loginError }}</p>
        }
        <label>
          {{ t('LoginEmailLabel') }}
          <input name="login" type="email" [(ngModel)]="login" autocomplete="username" required>
        </label>
        <label>
          {{ t('LoginPasswordLabel') }}
          <input name="password" type="password" [(ngModel)]="password" autocomplete="current-password" required>
        </label>
        <button type="submit">{{ t('LoginButton') }}</button>
      </form>
    </main>
  }
  @if (activeSession.authenticated) {
    <div class="hub-authenticated-shell" [ngStyle]="{'--accent-color': activeSession.ngo?.color || '#172033'}">
      <nav class="hub-nav tab-list" role="tablist">
        @for (item of visibleNavItems(); track item) {
          <a class="tab-button" role="tab" [routerLink]="item.route" routerLinkActive="active">{{ t(item.labelKey) }}</a>
        }
      </nav>
      <div class="hub-mobile-nav">
        <select class="mobile-tab-select" [ngModel]="currentNavRoute()" (ngModelChange)="navigate($event)" aria-label="Hub navigation">
          @for (item of visibleNavItems(); track item) {
            <option [value]="item.route">{{ t(item.labelKey) }}</option>
          }
        </select>
      </div>
      <section class="hub-content">
        <router-outlet />
      </section>
    </div>
  }
}
